import React from 'react'
import PropTypes from 'prop-types'
import OrderLoss from './orderLoss/orderLoss'
import LossMitigation from './lossMitigation/lossMitigation'
import MSTNLoss from './mstnLoss/MSTNLoss'
const LossRecoveryKPI = ({ data }) => {
    return (
        <>
            <OrderLoss data={data[0]?.OrderLoss} />
            <div style={{display:"flex",width:"100%"}}>
            <MSTNLoss data={data[1]?.TotalMSTNLoss}/>
            <LossMitigation data={data[2]?.LossMitigation} />
            </div>
        </>
    )
}

LossRecoveryKPI.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      OrderLoss: PropTypes.any,
      TotalMSTNLoss: PropTypes.any,
      LossMitigation: PropTypes.any,
    })
  ),
};

export default LossRecoveryKPI